// ─── Data Constants ───
export const TABLES = [
  { id: "revenue", name: "Revenue", nums: ["revenue_amount", "arpu", "revenue_pct", "new_revenue", "termination_revenue", "net_new_revenue"], texts: ["customer", "product", "business_vertical", "region"] },
  { id: "subscribers", name: "Subscribers / Links", nums: ["total_subs", "gross_new", "reconnections", "net_new", "terminations"], texts: ["customer", "product", "business_vertical", "region"] },
  { id: "units", name: "Units", nums: ["units_sold", "units_returned", "net_units"], texts: ["customer", "product", "business_vertical", "region"] },
  { id: "products", name: "Products", nums: ["product_revenue", "product_units", "product_margin"], texts: ["product_name", "product_category", "business_vertical"] },
  { id: "customers", name: "Customers", nums: ["customer_revenue", "customer_units", "customer_arpu"], texts: ["customer_name", "customer_segment", "business_vertical"] },
  { id: "churn", name: "Churn", nums: ["churn_rate", "churn_count", "retention_rate"], texts: ["customer", "product", "business_vertical", "reason"] },
  { id: "growth", name: "Growth", nums: ["growth_rate", "yoy_change", "mom_change"], texts: ["customer", "product", "business_vertical", "metric_type"] },
];

export const CHARTS = [
  { id: "stacked_bar", name: "Stacked Bar", ic: "Bar" },
  { id: "grouped_bar", name: "Grouped Bar", ic: "Bar" },
  { id: "line", name: "Line", ic: "Line" },
  { id: "waterfall", name: "Waterfall", ic: "Bar" },
  { id: "table", name: "Table", ic: "Tbl" },
];

export const PERCENTAGE_MAP: Record<string, string> = {
  stacked_bar: "stacked_percentage_bar",
  grouped_bar: "grouped_percentage_bar",
  line: "line_percentage",
  table: "table_percentage",
};

export const REVERSE_PCT: Record<string, string> = Object.fromEntries(
  Object.entries(PERCENTAGE_MAP).map(([k, v]) => [v, k])
);

export const GROUPINGS = [
  "None", 
  "Top 10 + Others", 
  "Top 5 + Others", 
  "Customer & Others", 
  "Product & Others", 
  "By Product", 
  "By Customer", 
  "Custom"
];

export const REPEATS = [
  "None", 
  "Customer", 
  "Product", 
  "Business Vertical", 
  "Region"
];

export const FILTERS = [
  "None", 
  "Customer Only", 
  "Product Only", 
  "Customer Filter → Product Group", 
  "Product Filter → Customer Group"
];

export const LAYOUTS = [
  { id: "1", name: "1 col", cols: 1 }, 
  { id: "2", name: "2 col", cols: 2 }, 
  { id: "3", name: "3 col", cols: 3 }, 
  { id: "4", name: "4 col", cols: 4 }
];

export const INSIGHTS_POS = [
  { id: "none", name: "Off" }, 
  { id: "bottom", name: "Bottom" }, 
  { id: "right", name: "Right (35%)" }
];

export type DateRangeOption = {
  id: string;
  name: string;
  start: number | null;
  end: number | null;
  type?: string; // "fytd" | "p_fy" — used for FY-relative ranges resolved at runtime
};

export const DATE_RANGE_OPTIONS: DateRangeOption[] = [
  { id: "all",              name: "All Dates",                              start: null, end: null },
  { id: "last_12",          name: "Last 12 Months",                        start: 12,   end: 0    },
  { id: "last_13",          name: "Last 13 Months",                        start: 13,   end: 0    },
  { id: "last_13_excl_1",   name: "Last 13 Months (Excl. Most Recent)",    start: 13,   end: 1    },
  { id: "last_6",           name: "Last 6 Months",                         start: 6,    end: 0    },
  { id: "last_3",           name: "Last 3 Months",                         start: 3,    end: 0    },
  { id: "mom",              name: "Month on Month",                        start: 1,    end: 0    },
  { id: "mom_1",            name: "Month on Month - 1",                    start: 2,    end: 1    },
  { id: "fytd",             name: "FY to Date",                            start: null, end: null, type: "fytd" },
  { id: "p_fy",             name: "Previous FY",                           start: null, end: null, type: "p_fy"  },
];

// ─── Utility Functions ───
let _uid = 0;
export const uid = () => `u${++_uid}_${Date.now()}`;

export const G = (label: string, chart: string, table: string, metric: string, grouping: string = "None", filter: string = "None") => ({
  id: uid(), 
  label, 
  chartType: chart, 
  dataTable: table, 
  yAxisField: metric, 
  grouping, 
  filterContext: filter,
  dateField: "reporting_period",
  monthRangeStart: 13,
  monthRangeEnd: 0,
  trend: {
    enabled: false,
    label: label
  }
});

export const P = (name: string, graphs: any[], layout: string = "1", insights: string = "none") => ({
  id: uid(),
  name,
  layout,
  graphs,
  insights,
  fitGraphs: true,
});

export const S = (name: string, desc: string = "", repeatField: string = "None", addRepeat: string = "None") => ({
  id: uid(), 
  name, 
  description: desc, 
  repeatField, 
  additionalRepeat: addRepeat, 
  collapsed: false, 
  pages: [] as any[],
});
